import { poUploadJobIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const cancelPoUpload = {
  name: "cancelPoUpload" as const,
  input: z.object({ jobId: poUploadJobIdFormat.schema }),
  output: z.object({}),
};
